import { GTM_RemoveShopCart } from "@/tools/googleTagManager.js";
import { getLocalStorage } from "@/tools/localStorage.js";
import store from "@/store/index.js";

export class ShopCartProductTool {
  constructor() {
    this.shopCart = this.initShopCart(store.state.shopCartModule.shopcart);
    this.memberLogin = false;
    if (getLocalStorage("account_token")) {
      this.memberLogin = true;
    }
  }

  initShopCart = (shopCartData) => {
    let shopCart = JSON.parse(JSON.stringify(shopCartData));
    shopCart.forEach((item, itemIndex) => {
      let priceList = null;
      if (item.productData.IsCustom != "Y") {
        priceList = this.getProductPrice(item);
      } else {
        priceList = this.getCustomProductPrice(item);
      }

      shopCart[itemIndex].Price =
        parseInt(priceList.Price) * shopCart[itemIndex].amount;
      shopCart[itemIndex].SellPrice = () => {
        if (getLocalStorage("account_token")) {
          return (
            parseInt(priceList.MemberSellPrice) * shopCart[itemIndex].amount
          );
        } else {
          return parseInt(priceList.SellPrice) * shopCart[itemIndex].amount;
        }
      };
      shopCart[itemIndex].optionList = this.getCurrentOptions(item);
      shopCart[itemIndex].imageData = this.getPictureData(item);
      shopCart[itemIndex].addAmount = (count = 1) => {
        this.addAmount(item, count);
      };
      shopCart[itemIndex].minusAmount = (count) => {
        this.minusAmount(item, itemIndex, count);
      };
      shopCart[itemIndex].changeAmount = (count) => {
        this.changeAmount(item, itemIndex, count);
      };
    });
    return shopCart;
  };

  getCustomProductPrice = (shopCartItem) => {
    let changePrice = 0;
    // 讀取客製化商品的『價格異動資料』陣列
    shopCartItem.productData.CustomGoodsChangePrice.forEach((changeItem) => {
      let matchCount = 0;
      let changeIDList = changeItem.CustomSpecID;
      // 若『價格異動資料』類行為字串，則先分割為陣列
      if (typeof changeItem.CustomSpecID === "string") {
        changeIDList = changeItem.CustomSpecID.split(",");
      }

      // 判斷與目前選擇之選項是否完全相符
      changeIDList.forEach((id) => {
        shopCartItem.activeOption.indexOf(id) != -1 ? (matchCount += 1) : "";
      });

      // 若『價格異動資料』的選項ID陣列與目前選擇之選項ID完全相符，則紀錄異動價錢
      if (matchCount == changeIDList.length) {
        changePrice += parseInt(changeItem.ChangePrice);
      }
    });

    const Price =
      parseInt(shopCartItem.productData.CustomGoodsStock[0].Price) +
      changePrice;
    const SellPrice =
      parseInt(shopCartItem.productData.CustomGoodsStock[0].SellPrice) +
      changePrice;
    const MemberSellPrice =
      parseInt(shopCartItem.productData.CustomGoodsStock[0].MemberSellPrice) +
      changePrice;

    return {
      Price: Price,
      SellPrice: SellPrice,
      MemberSellPrice: MemberSellPrice,
    };
  };

  getProductPrice = (shopCartItem) => {
    let currentStock = null;
    // 一般商品
    currentStock = shopCartItem.productData.Stock.find(
      (stock) =>
        stock.ColorID == shopCartItem.activeOption[0] &&
        stock.SizeID == shopCartItem.activeOption[1]
    );

    return {
      Price: currentStock.Price,
      SellPrice: currentStock.SellPrice,
      MemberSellPrice: currentStock.MemberSellPrice,
    };
  };

  getCurrentOptions = (shopCartItem) => {
    let optionList = [];
    if (shopCartItem.productData.IsCustom == "Y") {
      // 客製化商品
      shopCartItem.activeOption.forEach((option) => {
        const currentOption = shopCartItem.productData.CustomSpecList.find(
          (spec) => spec.CustomSpecID == option
        );

        optionList.push({
          Title: currentOption.SpecCategoryTitle,
          Value: currentOption.SpecTitle,
        });
      });
    } else {
      // 一般商品
      const currentStock = shopCartItem.productData.Stock.find(
        (stock) =>
          stock.ColorID == shopCartItem.activeOption[0] &&
          stock.SizeID == shopCartItem.activeOption[1]
      );
      if (currentStock.ColorTitle != "無") {
        optionList.push({
          Title: shopCartItem.productData.Option1,
          Value: currentStock.ColorTitle,
        });
      }
      if (currentStock.SizeTitle != "無") {
        optionList.push({
          Title: shopCartItem.productData.Option2,
          Value: currentStock.SizeTitle,
        });
      }
    }
    return optionList;
  };

  getPictureData = (shopCartItem) => {
    // image data
    let imageData = shopCartItem.productData.Image1;
    if (shopCartItem.productData.IsCustom != "Y") {
      const images = shopCartItem.productData.Picture;
      const fullMatchImage = images.find(
        (item) =>
          item.ColorID == shopCartItem.activeOption[0] &&
          item.SizeID == shopCartItem.activeOption[1]
      );
      const endMatchImage = images.find(
        (item) => item.SizeID == shopCartItem.activeOption[1]
      );
      const startMatchImage = images.find(
        (item) => item.ColorID == shopCartItem.activeOption[0]
      );

      if (fullMatchImage) {
        imageData = fullMatchImage.Image;
      } else if (endMatchImage) {
        imageData = endMatchImage.Image;
      } else if (startMatchImage) {
        imageData = startMatchImage.Image;
      }
    }

    return imageData;
  };

  addAmount = (shopCartItem, count) => {
    const addShopCartItem = {
      product: shopCartItem.productData,
      options: shopCartItem.activeOption,
      amount: count,
    };
    if (getLocalStorage("account_token")) {
      store.dispatch("shopCartModule/AddShopCart", addShopCartItem);
    } else {
      store.commit("shopCartModule/AddShopCart", addShopCartItem);
    }
  };

  minusAmount = (shopCartItem, shopCartIndex, count) => {
    GTM_RemoveShopCart(shopCartItem, count == -1 ? shopCartItem.amount : count);
    if (getLocalStorage("account_token")) {
      store.dispatch("shopCartModule/RemoveShopCart", {
        index: shopCartIndex,
        amount: count,
      });
    } else {
      store.commit("shopCartModule/RemoveShopCart", {
        index: shopCartIndex,
        amount: count,
      });
    }
  };

  changeAmount = (shopCartItem, shopCartIndex, count) => {
    if (count > shopCartItem.amount) {
      this.addAmount(shopCartItem, count - shopCartItem.amount);
    } else {
      this.minusAmount(
        shopCartItem,
        shopCartIndex,
        shopCartItem.amount - count
      );
    }
  };
}
